import React from 'react';
import WebhooksContent from './WebhooksContent';
import { Container } from '@mui/material';
const WebhooksContainer = () => {
    return (React.createElement(Container, { maxWidth: 'xl' },
        React.createElement(WebhooksContent, null)));
};
export default WebhooksContainer;
